export default __webpack_public_path__ + "static/media/BlobDay.1c4ee53e.svg";